import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsPaymentList_template} from "../components/templates/transactionsPaymentList_template";
import {header} from "./header";
import {centralizedPayment_template} from "../components/templates/centralizedPayment_template";

declare var ko: any;
declare var page: any;

export class centralized_payment extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: centralizedPayment_template;
    protected pagination: pagination_template;

    protected getModuleName() {
        return "centralized_payment";
    }

    buildContent(): Array<Element> {

        this.elementsList = new centralizedPayment_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Generate Slips");
        return [this.elementsList.build()];
    }

    public fillPage(): void {
        this.elementsList.buildDatePickerCalendar();

        this.filterList();
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterSimpleOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();

    }

    protected filterSimpleCancel(){

    }

    protected filterSingleDateOnChange() {
        this.verifyPaymentForDate(true);
    }

    protected transactionPaymentListReorder() {
        this.filterList();
    }

    protected showNoneTransactionToPay() {

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "There's no transaction to pay!");
        this.getVnAppZone().showNotificationToModule();

    }

    protected filterList() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.elementsList.startAutoRefresh();
        this.elementsList.disablePayButton(false);

        let subViewModel = {
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker()
            },
            frequency: this.viewModel.list.frequency()
        };

        let usrReq_url: string = '/api/transactions/payments/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if (req.request.status == 200) {

                    obj.updateList(data);
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();

                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions');
                } else {
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    protected verifyPaymentForDate(showLoad) {

        // LOADING : starts
        if(showLoad){
            this.elementsList.builtTemplate.classList.add("loading");
            this.elementsList.disablePayButton(false);
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.elementsList.startAutoRefresh();

        let subViewModel = {
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker()
            },
            frequency: this.viewModel.list.frequency()
        };
        let brands = this.viewModel.list.brands();
        for (let brand of brands) {

            let formReq_url: string;
            if(brand().id == 0){
                formReq_url = '/api/valnet/transactions/payments/verify/';
            }else {
                formReq_url =  '/api/brand/' + brand().id + '/transactions/payments/verify/';
            }

            let formReq_params: Array<Array<string>> = [['data', ko.toJSON(subViewModel)]];
            let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

            XHRHdl.onReadyStateFunction = function (req, obj) {
                return function () {
                    if (req.request.readyState == 4) {

                        let responseParsed = JSON.parse(req.request.response);

                        if (req.request.status == 200) {

                            //obj.releaseLock();
                            // obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.data.brand.name + " Transactions have been paid successfully !");
                            if (responseParsed.data.brand) {
                                obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.brand.status);
                            }

                        } else if (responseParsed.type == 'error_validation') {
                            obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.brand.status);
                            obj.elementsList.validationsList.setMessages(responseParsed.validations);
                            window.scrollTo(0, 0);

                        } else if (responseParsed.type == 'error') {

                            obj.elementsList.validationsList.setSingleMessage({
                                field: "error",
                                label: req.request.status,
                                message: responseParsed.message
                            });
                            obj.elementsList.updateStatus(responseParsed.brand, responseParsed.status);
                            window.scrollTo(0, 0);
                        }

                        // LOADING : ends
                        obj.elementsList.builtTemplate.classList.remove("loading");
                    }
                }
            };

            XHRHdl.execute();
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any) {
        responseParsed.brands.push({id: 0, name: "Valnet", iconImage: "full-icon i-VN", status: "not executed"});
        this.elementsList.setBrands(responseParsed.brands);
        this.elementsList.setLastPayDate(responseParsed.lastPayDate);
        this.elementsList.setPaymentDate(responseParsed.paymentDate);
        this.elementsList.setPaymentFrequencies(responseParsed.paymentFrequencies);
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {
        let msg = "error: while obtaining the data - (" + responseParsed.message + ")";
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    protected pay() {

        this.elementsList.builtTemplate.classList.add("loading");

        if( "pay" in this.XHRHdls ){
            this.XHRHdls["pay" ].cancelAndReset();
        }

        let _this = this;
        let subViewModel = {
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker()
            },
            frequency: this.viewModel.list.frequency()
        };

        let brands = this.viewModel.list.brands();
        for (let brand of brands) {
            let formReq_url: string;
            if(brand().id == 0){
                formReq_url = '/api/valnet/transactions/payments/pay/';
            }else {
                formReq_url = '/api/brand/' + brand().id + '/transactions/payments/pay/';
            }
            let formReq_params: Array<Array<string>> = [['data', ko.toJSON(subViewModel)]];
            this.XHRHdls['pay'] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

            this.XHRHdls['pay'].mode = XMLHttpRequestHandler_requestType.POST;
            this.XHRHdls['pay'].onReadyStateFunction = function (req, obj) {
                return function () {
                    if (req.request.readyState == 4) {

                        let responseParsed = JSON.parse(req.request.response);

                        if (req.request.status == 200) {

                            //obj.releaseLock();
                            // obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.data.brand.name + " Transactions have been paid successfully !");
                            obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.status);

                        } else if (responseParsed.type == 'error_validation') {

                            obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.status);
                            obj.elementsList.validationsList.setMessages(responseParsed.validations);
                            window.scrollTo(0, 0);

                        } else if (responseParsed.type == 'error') {

                            obj.elementsList.validationsList.setSingleMessage({
                                field: "error",
                                label: req.request.status,
                                message: responseParsed.message
                            });
                            obj.elementsList.updateStatus(responseParsed.brand, responseParsed.status);
                            obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.message);

                            window.scrollTo(0, 0);
                        }

                        // LOADING : ends
                        obj.elementsList.builtTemplate.classList.remove("loading");
                    }
                }
            };

            this.XHRHdls['pay'].execute();
            this.elementsList.updateStatus(brand, "in progress");
        }

    }

    protected reverse_payment() {

        this.elementsList.builtTemplate.classList.add("loading");

        let _this = this;
        let subViewModel = {
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker()
            },
            frequency: this.viewModel.list.frequency()
        };
        let brands = this.viewModel.list.brands();
        for (let brand of brands) {

            let formReq_url: string;
            if(brand().id == 0){
                formReq_url = '/api/valnet/transactions/payment/reverse';
            }else {
                formReq_url =  '/api/brand/' + brand().id + '/transactions/payment/reverse';
            }

            let formReq_params: Array<Array<string>> = [['data', ko.toJSON(subViewModel)]];
            let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

            XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
            XHRHdl.onReadyStateFunction = function (req, obj) {
                return function () {
                    if (req.request.readyState == 4) {

                        let responseParsed = JSON.parse(req.request.response);

                        if (req.request.status == 200) {

                            //obj.releaseLock();
                            // obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Payment reversed successfully !");
                            obj.elementsList.validationsList.clearMessages();

                            // page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions/payments');
                            obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.status);

                        } else if (responseParsed.type == 'error_validation') {
                            obj.elementsList.updateStatus(responseParsed.data.brand, responseParsed.data.status);
                            // obj.elementsList.validationsList.setMessages(responseParsed.validations);
                            window.scrollTo(0, 0);

                        } else if (responseParsed.type == 'error') {

                            obj.elementsList.validationsList.setSingleMessage({
                                field: "error",
                                label: req.request.status,
                                message: responseParsed.message
                            });

                            obj.elementsList.updateStatus(responseParsed.brand, responseParsed.status);
                            obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.message);
                            window.scrollTo(0, 0);
                        }

                        // LOADING : ends
                        obj.elementsList.builtTemplate.classList.remove("loading");
                    }
                }
            };

            XHRHdl.execute();
            this.elementsList.updateStatus(brand, "in progress");
        }
    }

    protected getUserPaymentDetails(id) {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("summary-results"));

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            datePayment: this.viewModel.list.filterDate.singleDatePicker,
            idUser: id,
            frequency: this.viewModel.list.frequency()
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/user/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onTransactionRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onTransactionRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                if (req.request.status == 200) {
                    obj.updateUserTransactions(data);
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);

                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions');
                } else {
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("summary-results"));
            }
        }
    }

    //
    // update the list of transactions for the specified user
    protected updateUserTransactions(responseParsed: any) {
        // set users list
        let users = this.viewModel.list.users();
        let idUser = responseParsed.user;
        let index = users.map(function (x) {
            return x.user_id;
        }).indexOf(idUser);

        for (let item of responseParsed.transactions) {

            var project_name, total, dateScheduled, idYoutube;
            var entry_type = item.entry_type;

            if (item.action_type_id == 3 || item.project_name == null) {
                project_name = "N/A";
                idYoutube = "N/A";
            } else {
                project_name = item.project_name.substring(0, 40) + '...';
                idYoutube = item.idYoutube;
            }

            if (item.action_type_id == 2) {
                entry_type = "Reversal of " + entry_type;
            }

            total = (item.type_id == 1) ? '-$' + Number(item.total).toLocaleString(undefined, {minimumFractionDigits: 2}) : '$' + Number(item.total).toLocaleString(undefined, {minimumFractionDigits: 2});
            dateScheduled = item.dateScheduled.substring(0, 10);

            users[index].transactions.push({
                entry_type: entry_type
                , project_name: project_name
                , idYoutube: idYoutube
                , dateCreation: dateScheduled
                , amount: total
            });
        }
        // this.elementsList.setUsers([]);
        // this.elementsList.setUsers(users);
    }

    public onChangePaymentView(idPaymentView) {
        this.viewModel.list.isSummaryVisible(!this.viewModel.list.isSummaryVisible());
        if (this.viewModel.list.users().length == 0 && idPaymentView == 1) {
            // this.getPaymentSummary();
        }
    }

    protected getPaymentSummary() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("summary-results"));

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let subViewModel = {
            datePayment: this.viewModel.list.filterDate.singleDatePicker,
            frequency: this.viewModel.list.frequency()
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/summary/preview/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onSummaryRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onSummaryRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if (req.request.status == 200) {

                    obj.updateSummary(data);
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                } else {
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("summary-results"));
            }
        }
    }

    protected updateSummary(responseParsed: any) {

        // set users list
        let users = [];
        if (responseParsed.users) {
            for (let item of responseParsed.users) {
                var total = (item.total < 0) ? '$0.00 ($' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2}) + ')' : '$' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2});

                users.push({
                    total: total
                    , user_id: item.id
                    , user_fullName: item.fullName
                    , paymentEmail: item.paymentEmail
                    , currency: item.currency
                    , transactions: []
                    , showDetails: false
                })
            }
        }
        // this.elementsList.setUsers(users);
    }

    //

    public filterDropdownOnChange() {

        this.elementsList.setFrequency(this.elementsList.getFrequency());
        this.filterList();
    }

    public filterAutoRefreshStatusOnChange(){

        this.verifyPaymentForDate(false);
    }

    public autoRefresh(){
        this.verifyPaymentForDate(false);
    }
}



// WEBPACK FOOTER //
// ./js/modules/centralized_payment.ts